import React, { useMemo } from "react";
import { format } from "date-fns";

export default function LeadCard({
  lead,
  onEdit,
  onRepeat,
  onDelete,
  onDropdownToggle,
}) {
  const statusMeta = useMemo(() => {
    const status = lead.status;
    const meta = {
      bg: "bg-light",
      border: "border-light",
      badge: "secondary",
    };

    if (status === "Closed") {
      meta.bg = "bg-success-subtle";
      meta.border = "border-success-subtle";
      meta.badge = "success";
    } else if (status === "Follow Up") {
      meta.bg = "bg-info-subtle";
      meta.border = "border-info-subtle";
      meta.badge = "primary";
    } else if (status === "Rejected") {
      meta.bg = "bg-danger-subtle";
      meta.border = "border-danger-subtle";
      meta.badge = "danger";
    } else if (status === "Booking") {
      meta.bg = "bg-warning-subtle";
      meta.border = "border-warning-subtle";
      meta.badge = "warning";
    }

    return meta;
  }, [lead.status]);

  return (
    <div
      className={`card mb-3 shadow-sm ${statusMeta.border} border-1 card-interactive`}
      style={{ cursor: "pointer" }}
      onClick={onEdit}
    >
      <div className="card-header d-flex justify-content-between align-items-center">
        <div className="card-title mb-0 text-truncate" style={{ fontSize: "0.95rem" }}>
          {lead.name}
        </div>
        <span className={`badge rounded-pill text-bg-${statusMeta.badge}`}>
          {lead.status}
        </span>
      </div>

      <div className={`card-body ${statusMeta.bg}`} style={{ fontSize: "0.9rem" }}>
        <p className="card-text mb-2">
          <i className="bi bi-phone me-2 text-muted"></i> +{lead.country}
          {lead.phone}
        </p>

        {lead.remark ? (
          <p
            className="card-text text-muted fst-italic"
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            title={lead.remark}
          >
            <i className="bi bi-chat-left-text me-2"></i>"{lead.remark}"
          </p>
        ) : (
          <p className="card-text text-muted fst-italic">
            <i className="bi bi-chat-left-text me-2"></i>"No Remarks"
          </p>
        )}
      </div>

      <div
        className="card-footer d-flex justify-content-between align-items-center text-muted"
        style={{ fontSize: "0.85rem" }}
        onClick={(e) => e.stopPropagation()}
      >
        <span>Added: {format(new Date(lead.createdAt), "dd MMM yyyy")}</span>

        <div className="d-flex align-items-center">
          <div className="btn-group">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={onDropdownToggle}
            >
              <i className="bi bi-gear-fill"></i>
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              {lead.status === "Closed" && (
                <>
                  <li>
                    <button className="dropdown-item" onClick={onRepeat}>
                      <i className="bi bi-arrow-repeat me-2"></i>Repeat Sale
                    </button>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                </>
              )}
              <li>
                <a
                  className="dropdown-item text-success"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://api.whatsapp.com/send?phone=${lead.country + lead.phone}`}
                >
                  <i className="bi bi-whatsapp me-2"></i>WhatsApp
                </a>
              </li>
              <li>
                <a className="dropdown-item" href={`tel:${lead.country}${lead.phone}`}>
                  <i className="bi bi-telephone-forward me-2"></i>Call
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button
                  className="dropdown-item text-danger"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteDB"
                  onClick={onDelete}
                >
                  <i className="bi bi-person-x-fill me-2"></i>Delete
                </button>
              </li>
            </ul>
          </div>

          <button
            className="btn btn-sm btn-outline-secondary ms-2"
            onClick={onEdit}
            title="Edit"
          >
            <i className="bi bi-pencil-fill"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
